/*
 * @描叙:  
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-03-21 16:20:10 
*/
var Machine_Editor = null;

(function() {
    /**
 * 基于jtopo-editor.js的二次封装
 * designed by xwenyuan
 * github: https://github.com/xwenyuan/jtopo_topology.git
 */
    /**
     * 提供拓扑图面板相关操作的函数集，编辑器继承其全部功能
     */
    function TopologyPanel() {
    }
    /**
     * 编辑器对象,原型继承拓扑图面板对象,提供编辑器的主要功能
     */
    function TopologyEditor() {
        // 绘图参数
        this.config = {
            // Stage属性
            stageFrames: 500,                       // 舞台播放的帧数/秒
            defaultScal: 0.95,                      // 鼠标滚轮缩放比例
            eagleEyeVsibleDefault: false,         // 是否显示鹰眼对象
            // Node属性
            nodeAlpha: 1,                           // 节点透明度,取值范围[0-1]
            nodeStrokeColor: '22,124,255',        // 节点描边的颜色
            nodeFillColor: '22,124,255',          // 节点填充颜色
            nodeShadow: false,                     // 节点是否显示阴影
            nodeShadowColor: 'rgba(0,0,0,0.5)',  // 节点阴影的颜色
            nodeFont: '12px Consolas',            // 节点字体
            nodeFontColor: 'black',               // 节点文字颜色,如"255,255,0"
            nodeDefaultWidth: 32,                 // 新建节点默认宽
            nodeDefaultHeight: 32,                // 新建节点默认高
            nodeBorderColor: 'black',            // 节点容器边框颜色,如"255,255,0"
            nodeBorderRadius: 30,                // 节点半径，非圆节点有此属性会变形
            nodeRotateValue: 0.5,                // 节点旋转的角度(弧度)
            nodeScale: 0.2,                       // 节点缩放幅度(此处保证X和Y均等缩放)
            // Link属性
            linkAlpha: 1,                         // 连线透明度,取值范围[0-1]
            linkStrokeColor: '0,153,255',     // 连线的颜色
            linkFillColor: '0,153,255',
            linkShadow: false,                   // 是否显示连线阴影
            linkShadowColor: 'rgba(0,0,0,0.5)',
            linkFont: '12px Consolas',           // 节点字体
            linkFontColor: 'black',              // 连线文字颜色,如"255,255,0"
            linkArrowsRadius: 0,                 // 线条箭头半径
            linkDefaultWidth: 12,                 // 连线宽度
            linkOffsetGap: 100,                   // 折线拐角处的长度
            linkDirection: 'horizontal',        // 折线的方向
            // Container属性
            containerAlpha: 0.5,
            containerStrokeColor: '255,255,255',
            containerFillColor: '255,255,255',
            containerShadow: false,
            containerShadowColor: 'rgba(255,255,255,.3)',
            containerFont: '12px Consolas',
            containerBorderRadius: 30
        }
        this.canvas = null;
        this.canvasHeight = 0;
        this.canvasWidth = 0;
        // 布局参数
        this.layout = {}
        // 绘图区属性
        this.stage = null
        this.scene = null
        this.container = null
        // 当前模式
        this.stageMode = 'normal'
        // 默认连线类型
        this.lineType = 'line'
        // 当前选择的节点对象
        this.currentNode = null
        // 当前选择的连线对象
        this.currentLink = null
       
        TopologyPanel.call(this)
    }

    // 原型继承
    TopologyEditor.prototype = new TopologyPanel()

    /**
     * 编辑器初始化方法,根据请求返回结果加载空白的或者指定结构的拓扑编辑器
     * @param topologyGuid  拓扑记录ID
     * @param backImg     背景图片
     * @param topologyJson    拓扑JSON结构
     */
    TopologyEditor.prototype.init = function (topologyJson) {
        if (!topologyJson) {
            // alert('加载拓扑编辑器失败!')
            return
        }
        // 创建jTopo舞台屏幕对象
        let canvas = document.getElementById('topology-canvas')
        canvas.width = $('#topology-body').width();
        canvas.height = $('#topology-body').height();
        this.canvas = canvas.getContext('2d');
        this.canvasWidth = $('#topology-body').width();
        this.canvasHeight = $('#topology-body').height();
        // 加载空白的编辑器
        if (topologyJson === '-1') {
            this.stage = new JTopo.Stage(canvas)         // 定义舞台对象
            this.scene = new JTopo.Scene(this.stage)    // 定义场景对象
            this.container = new JTopo.Container();
            this.container.width = canvas.width;
            this.container.height = canvas.height;
            this.container.alpha = 0
            this.container.strokeColor = this.config.containerStrokeColor
        } else {
            this.stage = JTopo.createStageFromJson(topologyJson, canvas)    // 根据保存好的jsonStr(拓扑结构)创建舞台对象
            this.scene = this.stage.childs[0]                           // 场景对象列表,childs是舞台的属性
        }
        // 滚轮缩放
        this.stage.frames = this.config.stageFrames       // 设置当前舞台播放的帧数/秒
        this.stage.wheelZoom = this.config.defaultScal    // 鼠标滚轮缩放操作比例
        this.stage.eagleEye.visible = this.config.eagleEyeVsibleDefault    // 是否开启鹰眼
        this.stage.mode = this.stageMode


        let self = this

        // 鼠标进入事件
        this.scene.mouseover(function (event) {
            Timer.start()
            // 进入某个节点
            
        })

        // 鼠标离开事件
        this.scene.mouseout(function (event) {
            let timeSpan = Timer.pause()
            // 消抖
            if (timeSpan > 100) {
               
                Timer.stop()
            }
        })

        // 鼠标单击节点事件
        this.scene.click(function (event) {
            console.log("单击");
            if (event.target) {
                Machine_Editor.handlerClick && Machine_Editor.handlerClick(event.target)
            }
            
        })

        // 双击事件
        this.scene.dbclick(function (event) {
            console.log("双击");
            if (event.target) {
                Machine_Editor.handlerdbClick && Machine_Editor.handlerdbClick(event.target)
            }
        })

        // 监听鼠标松开事件
        // 处理右键菜单、左键连线
        // event.button: 0-左键 1-中键 2-右键
        this.scene.mouseup(function (event) {
            
        })

        this.scene.mousedrag(function (event) {
            if (!self.isSelectedMode && self.beginNode) {
                self.tempNodeZ.setLocation(event.x, event.y)
            }
        })

        // 单击编辑器隐藏右键菜单
        this.stage.click(function (event) {
            console.log("单击编辑器隐藏右键菜单" + event);
            
        })
        
    }
    
    // 编辑器实例
    var editor = new TopologyEditor('mainControl')

    // 工具方法
    editor.utils = {
        // 获取所有分组
        getAllContainers: function () {
            return editor.stage.find('container')
        },
        // 获取所有节点
        getAllNodes: function () {
            return editor.stage.find('node')
        },
        // 获取所有连线
        getAllLinks: function () {
            return editor.stage.find('link')
        },
        // 获取所有选择的节点实例
        getSelectedNodes: function () {
            let selectedNodes = []
            let nodes = editor.scene.selectedElements
            nodes.forEach(function (n) {
                if (n.elementType === 'node') {
                    selectedNodes.push(n)
                }
            })
            return selectedNodes
        },
        // 节点分组合并
        toMerge: function () {
            let selectedNodes = this.getSelectedNodes()
            // 不指定布局的时候,容器的布局为自动(容器边界随元素变化）
            let container = new JTopo.Container()
            container.textPosition = 'Top_Center'
            container.fontColor = editor.config.nodeFontColor
            container.borderColor = editor.config.nodeBorderColor
            container.borderRadius = editor.config.nodeBorderRadius
            editor.scene.add(container)
            selectedNodes.forEach(function (n) {
                container.add(n)
            })
        },
        // 分组拆除
        toSplit: function () {
            if (editor.currentNode instanceof JTopo.Container) {
                editor.currentNode.removeAll()
                editor.scene.remove(editor.currentNode)
            }
        },
        // 删除连线
        deleteLine: function () {
            if (editor.currentNode instanceof JTopo.Link) {
                editor.scene.remove(editor.currentNode)
                // if (editor.currentNode.id)
                //     editor.deleteNodeById(editor.currentNode.id, "link");
                editor.currentNode = null
                editor.lineMenu.hide()
            }
        },
        // 删除节点
        deleteNode: function (n) {
            editor.scene.remove(n)
            // if (n.id)
            //     editor.deleteNodeById(n.id, n.elementType, n.dataType);
            editor.currentNode = null
            // 连线重置
            editor.beginNode = null
            if (editor.link) {
                editor.scene.remove(editor.link)
            }
            editor.link = null
        },
        // 删除选择的节点
        deleteSelectedNodes: function () {
            if (editor.stageMode !== 'edit') {
                return false
            }
            let self = this
            let nodes = editor.scene.selectedElements
            if (nodes && nodes.length > 0) {
                for (let i = 0; i < nodes.length; i++) {
                    self.deleteNode(nodes[i])
                }
            }
        },
        // 放大
        scalingBig: function () {
            if (editor.currentNode instanceof JTopo.Node) {
                editor.currentNode.scaleX += editor.config.nodeScale
                editor.currentNode.scaleY += editor.config.nodeScale
				
            } else {
                editor.stage.zoomOut(editor.stage.wheelZoom)
            }
        },
        // 缩小
        scalingSmall: function () {
            if (editor.currentNode instanceof JTopo.Node) {
                editor.currentNode.scaleX -= editor.config.nodeScale
                editor.currentNode.scaleY -= editor.config.nodeScale
            } else {
                editor.stage.zoomIn(editor.stage.wheelZoom)
				console.log(editor.stage.wheelZoom)
            }
        },
        // 顺时针旋转
        rotateAdd: function () {
            if (editor.currentNode instanceof JTopo.Node) {
                editor.currentNode.rotate += editor.config.nodeRotateValue
            }
        },
        // 逆时针旋转
        rotateSub: function () {
            if (editor.currentNode instanceof JTopo.Node) {
                editor.currentNode.rotate -= editor.config.nodeRotateValue
            }
        },
        // 清空编辑器
        clearTopology: function () {
            // 删除节点表对应的节点记录
            editor.deleteAllNodes()
        },
        // 拓扑图预览
        showPic: function () {
            editor.stage.saveImageInfo()
        },
        exportAsImage: function () {
            editor.stage.exportAsImage()
        },
        setEditMode: function () {
            editor.stageMode = 'edit'
        },
        setNormalMode: function () {
            editor.stageMode = 'normal'
        },
        // 复制节点
        cloneNode: function (n) {
            if (n instanceof JTopo.Node) {
                let newNode = new JTopo.Node()
                n.serializedProperties.forEach(function (i) {
                    // 只复制虚拟机的模板属性
                    // if (i == "templateId" && n.dataType != "VM") return true;
                    newNode[i] = n[i]
                })
                newNode.nodeId = generateUUID()
                newNode.alpha = editor.config.nodeAlpha
                newNode.strokeColor = editor.config.nodeStrokeColor
                newNode.fillColor = editor.config.nodeFillColor
                newNode.shadow = editor.config.nodeShadow
                newNode.shadowColor = editor.config.nodeShadowColor
                newNode.font = editor.config.nodeFont
                newNode.fontColor = editor.config.nodeFontColor
                newNode.borderRadius = null
                newNode.layout = n.layout
                newNode.selected = false
                // var deviceNum = ++editor.modeIdIndex;
                // newNode.deviceId = "device" + deviceNum;
                newNode.setLocation(n.x + n.width, n.y + n.height)
                newNode.text = n.text
                newNode.setImage(n.image)
                editor.scene.add(newNode)
            }
        },
        // 复制选择的节点
        cloneSelectedNodes: function () {
            let self = this
            let nodes = editor.scene.selectedElements
            nodes.forEach(function (n) {
                if (n.elementType === 'node') {
                    self.cloneNode(n)
                }
            })
        },
        // 全屏显示
        showInFullScreen: function (element, method) {
            let usablePrefixMethod;
            ['webkit', 'moz', 'ms', 'o', ''].forEach(function (prefix) {
                if (usablePrefixMethod) {
                    return
                }
                if (prefix === '') {
                    // 无前缀，方法首字母小写
                    // method = method.slice(0, 1).toLowerCase() + method.slice(1)
                }
                let typePrefixMethod = typeof element[prefix + method]
                if (typePrefixMethod + '' !== 'undefined') {
                    if (typePrefixMethod === 'function') {
                        usablePrefixMethod = element[prefix + method]()
                    } else {
                        usablePrefixMethod = element[prefix + method]
                    }
                }
            }
            )
            return usablePrefixMethod
        },
        // 居中显示
        showInCenter: function () {
            editor.stage.centerAndZoom()
        },
        // 获取所有的容器对象
        getContainers: function () {
            let containers = []
            editor.stage.childs.forEach(function (s) {
                s.childs.forEach(function (n) {
                    if (n.elementType === 'container') {
                        containers.push(n)
                    }
                })
            })
            return containers
        },
        // 根据指定的key返回节点实例
        getNodeByKey: function (key, value) {
            let node = null
            editor.stage.childs.forEach(function (s) {
                s.childs.forEach(function (n) {
                    if (n.elementType === 'node' && n[key] === value) {
                        node = n
                        return node
                    }
                })
            })
            return node
        },
        getTextNodeByKey: function (key, value) {
            let node = null
            editor.stage.childs.forEach(function (s) {
                s.childs.forEach(function (n) {
                    if (n.elementType === 'TextNode' && n[key] === value) {
                        node = n
                        return node
                    }
                })
            })
            return node
        },
        // 撤销对节点的操作
        cancleNodeAction: function () {
            if (editor.currentNode.currStep <= 0) {
                return
            }
            --editor.currentNode.currStep
            for (let p in editor.currentNode) {
                if (p !== 'currStep') {
                    editor.currentNode[p] = (editor.currentNode.historyStack[editor.currentNode.currStep])[p]
                }
            }
        },
        // 重做节点操作
        reMakeNodeAction: function () {
            if (editor.currentNode.currStep >= editor.currentNode.maxHistoryStep ||
                editor.currentNode.currStep >= editor.currentNode.historyStack.length - 1) {
                return
            }
            editor.currentNode.currStep++
            for (let q in editor.currentNode) {
                if (q !== 'currStep') {
                    editor.currentNode[q] = (editor.currentNode.historyStack[editor.currentNode.currStep])[q]
                }
            }
        },
        // 保存节点新的状态
        saveNodeNewState: function () {
            // 如果历史栈超过最大可记录历史长度，丢弃第一个元素
            if (editor.currentNode.historyStack.length >= editor.currentNode.maxHistoryStep + 1) {
                editor.currentNode.historyStack.shift()
            }
            editor.currentNode.historyStack.push(JTopo.util.clone(editor.currentNode))
            editor.currentNode.currStep = editor.currentNode.historyStack.length - 1
        },
        // 保存节点初始状态,便于回退
        saveNodeInitState: function () {
            if (!editor.currentNode.hasInitStateSaved) {
                editor.currentNode.historyStack.push(JTopo.util.clone(editor.currentNode))
                editor.currentNode.hasInitStateSaved = true
            }
        },
        // 查找节点,便居中闪动显示
        findNodeAndFlash: function (text) {
            if (!text) return
            // var self = this
            text = text.trim()
            let nodes = editor.stage.find('node[text="' + text + '"]')
            if (nodes.length > 0) {
                let node = nodes[0]
                this.unSelectAllNodeExcept(node)
                node.selected = true
                let location = node.getCenterLocation()
                // 查询到的节点居中显示
                editor.stage.setCenter(location.x, location.y)
                
            } else {
                // alert('没有找到该节点,请输入完整的节点名称!')
            }
        },
        // 取消出参数节点外所有节点的选中状态
        unSelectAllNodeExcept: function (node) {
            editor.stage.childs.forEach(function (s) {
                s.childs.forEach(function (n) {
                    // id属性无有效值，说明该节点没有保存到数据库
                    if (n.nodeId !== node.nodeId) {
                        n.selected = false
                    }
                })
            })
        }
    }
    Machine_Editor = editor

    // 扩展绘制虚线动画
    TopologyEditor.prototype.LineDash = function(moveTo, LineTo, direction = true, color = "red") {
        let offSet = 0;
        let van = this.canvas;
        return setInterval(function () {
            // 清除矩形内所有内容
            
            // 开始一次绘制
            van.beginPath();
            van.lineDashOffset = direction ? -offSet : offSet;
            van.strokeStyle = color;
            // 设置虚线排列
            van.setLineDash([10]);
            // 设置虚线偏移量
            van.lineWidth = 4;
            van.moveTo(moveTo.x, moveTo.y);
            van.lineTo(LineTo.x, LineTo.y);
            // 执行绘制
            van.stroke();
            // 关闭此次绘制
            van.closePath();
            if (offSet > 390) {
                offSet = 0;
            }
            offSet += 1;
        }, 40)
    }
})()


export default Machine_Editor;
